import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { EntityStatus, initialStatus } from 'projects/angular-clarity/src/app/stores/status.interface';
import * as actions from './actions';
import { Iso3166_2Country } from './model';

export const featureKey = 'iso3166_2CountryCodes';

export interface State extends EntityState<Iso3166_2Country>, EntityStatus {}

export const adapter = createEntityAdapter<Iso3166_2Country>({
    selectId: (item: Iso3166_2Country) => item.code,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,

    on(actions.loadIso3166_2CountryCodesSuccess, (state, { data }) =>
        adapter.upsertMany(data, {
            ...state,
            loading: false,
            loaded: true,
        }),
    ),
    on(actions.loadIso3166_2CountryCodesFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false,
        updating: false,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
